module.exports = __webpack_public_path__ + "a3c081fd745d94d4da95887e6ca13c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/routes/Welcome/welcome.png
// module id = 1054
// module chunks = 0